import React, { FC } from 'react';
import styled from 'styled-components/macro';

import media from 'helpers/media';

import FormField from './field';
import FormInput from './input';
import FormSelect from './select';
import FormTextarea from './textarea';
import FormCheckbox from './checkbox';
import FormRadio from './radio';
import FormPasswordField from './input-password';

const FormStyled = styled.form`
    display: flex;
    flex-wrap: wrap;

    &:not(:first-child) {
        margin-top: ${({ theme }) => theme.space.large};
    }

    ${({ theme }) => media.mobile`
        &:not(:first-child) {
            margin-top: ${theme.space.base};
        }
    `};
`;

const Form: FC<React.FormHTMLAttributes<HTMLFormElement>> = (args) => {
    return <FormStyled {...args}>{args.children}</FormStyled>;
};

export default Form;

export {
    FormField,
    FormInput,
    FormSelect,
    FormTextarea,
    FormCheckbox,
    FormRadio,
    FormPasswordField,
};
